module.exports = __webpack_public_path__ + "static/Plate IQ-5c53814bc7a573ae1a0e15ccb3c162cc.jpg";